import React, { useState,useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import "./signin.css";
import shop_logo from "../../images/splash/herbal.jpeg";
import axios from "axios";
import Swal from "sweetalert2";
import { var_api } from "../constant";
import { Card, CardTitle, CardSubtitle, CardBody, Tooltip } from "reactstrap";
import Loader from "../Loader/Loader";

const SignIn = () => {
  const history = useHistory();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  // Validation state
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");

  const toggleTooltip = () => {
    setTooltipOpen(!tooltipOpen);
  };

  const validateForm = () => {
    let isValid = true;

    // Email validation
    if (!email) {
      setEmailError("Email is required.");
      isValid = false;
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setEmailError("Enter a valid email.");
      isValid = false;
    } else {
      setEmailError("");
    }

    // Password validation
    if (!password) {
      setPasswordError("Password is required.");
      isValid = false;
    } else {
      setPasswordError("");
    }

    return isValid;
  };

  const handleSignIn = async (e) => {
    e.preventDefault();

    // Check form validity
    if (!validateForm()) return;
    setIsLoading(true);

    try {
      const loginResponse = await axios.post(`${var_api}admin-signin`, {
        email,
        password,
      });

      const { token, id, userName } = loginResponse.data;

      // Update token
      await axios.put(`${var_api}update-admin-token/${id}/${email}`, {
        admin_id: id,
        email,
        token,
      });

      localStorage.setItem("Token", token);
      localStorage.setItem("ShopId", id);
      localStorage.setItem("username", userName);

        // Show success message with auto-close
      // Show success toast message for 1 second
      Swal.fire({
        icon: "success",
        title: "Login successful!",
        toast: true,
        position: "top-end", // Position at the top-right corner
        showConfirmButton: false,
        timer: 2000, // Auto-close after 1 second (1000ms)
        timerProgressBar: true, // Show a progress bar
        background: '#00000', // Optional: green background for success
      })


      history.push("/home");
    } catch (error) {
      console.error("Error during login or token signin:", error);
      setIsLoading(false);
      await Swal.fire({
        icon: "error",
        title: `${error.response.data.message}`,
        text: "Failed to login . Please try again.",
      });
    }
    finally{
      setIsLoading(false);
    }
  };
  useEffect(() => {
    // Prevent back button navigation after logout
    window.history.pushState(null, null, window.location.href);
    window.onpopstate = function () {
      history.replace('/');
    };

    return () => {
      // Clean up the event listener when component unmounts
      window.onpopstate = null;
    };
  }, [history]);

  return (
    <div className="sign-up">
      {isLoading && <Loader />}
      {/* <Tooltip
        isOpen={tooltipOpen}
        target="saButton"
        toggle={toggleTooltip}
        placement="right"
      >
        Super Admin
      </Tooltip> */}
      {/* <button
        className="btn btn-success m-2"
        id="saButton"
        onClick={toggleTooltip}
      >
        <i className="bi bi-person"></i>
      </button> */}
      <br />
      <br />

      <Card id="signupcard">
        <CardBody>
          <CardTitle style={{ textAlign: "center" }}>
            <Link to="/" className="navbar-brand">
              <img src={shop_logo} alt="logo" id="signinLogo" style={{borderRadius:"50%"}} />
            </Link>
          </CardTitle>
          <CardSubtitle>
            <div className="container" id="containdiv">
            <form className="py-2" onSubmit={handleSignIn}>
  <h6
    className="lead text-center py-2"
    style={{
      fontSize: "20px",
      fontWeight: "bold",
      fontFamily: "sans-serif",
    }}
  >
    Login
  </h6>

  {/* Email Field */}
  <div className="form-group">
    <label className="form-label text-success fw-bold m-0">Email</label>
    <input
      type="email"
      className={`form-control ${emailError ? "is-invalid" : ""}`}
      value={email}
      onChange={(e) => setEmail(e.target.value)}
      placeholder="Email"
      required
      style={{
        height: "45px",
        borderRadius: "20px",
        padding: "0 15px",
        boxSizing: "border-box",
      }}
    />
    {emailError && <div className="invalid-feedback">{emailError}</div>}
  </div>
  <br />

  {/* Password Field */}
  <div className="form-group">
    <label className="form-label text-success fw-bold m-0">Password</label>
    <div
      className="input-group"
      style={{
        position: "relative",
      }}
    >
      <input
        type={showPassword ? "text" : "password"}
        className={`form-control ${passwordError ? "is-invalid" : ""}`}
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        placeholder="Password"
        required
        style={{
          height: "45px",
          borderRadius: "20px",
          paddingRight: "50px", // Leaves space for the button
          paddingLeft: "15px",
          boxSizing: "border-box",
        }}
      />
      <button
        type="button"
        className="btn"
        onClick={() => setShowPassword(!showPassword)}
        style={{
          position: "absolute",
          top: "40%",
          right: "10px",
          transform: "translateY(-50%)",
          backgroundColor: "transparent",
          border: "none",
          fontSize: "20px",
          cursor: "pointer",
          zIndex: 10, // Ensures the button stays above the input
        }}
      >
        {showPassword ? (
          <i className="bi bi-eye-slash-fill"></i>
        ) : (
          <i className="bi bi-eye-fill"></i>
        )}
      </button>
    </div>
    {passwordError && <div className="invalid-feedback">{passwordError}</div>}
  </div>
  <br />

  <div className="d-grid">
    <button className="btn btn-success btn-block" type="submit">
      Login
    </button>
  </div>
</form>

            </div>
          </CardSubtitle>
        </CardBody>
      </Card>
    </div>
  );
};

export default SignIn;
  